export default __webpack_public_path__ + "static/media/22.9aa0954f.png";